export const APP_INPUT_MAX_LENGTH = 50;
